/**
 * Handle's checking for limited/no stock when selecting a size swatch for a product on the PDP
 */
define([
    'jquery'
], function ($) {
    'use strict';

    $(".swatch-opt").on('click', '.swatch-option', handlerClickSizeSwatch);

    function handlerClickSizeSwatch(e) {
        var $swatch = $(e.target);
        if ($swatch.hasClass('out-of-stock')) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }

        if (!$swatch.hasClass("out-of-stock")) {
            checkStockLevel($swatch);
        }
    }

    /**
     * Check the stock level for a size of a product
     *
     * Will update the interface with a message indicating low stock, if there is low stock
     *
     * @params {jQuery} $swatch The selected size swatch
     *
     * @return null
     */
    function checkStockLevel($swatch) {
        var $addToBagForm = $("#product_addtocart_form")
            .find("input[name^='super_attribute']")
            .attr('name', 'super_attribute['+$swatch.closest(".swatch-attribute").data('attribute-id')+']')
            .val($swatch.attr('option-id'))
            .end();


        $.ajax({
            url: "/munro_catalog/index/checklowstockforsize",
            type: 'POST',
            data: $addToBagForm.serialize()
        })
        .done(function(data) {
            var $productStockMessage = $(".product__stock-message");
            if (data.message) {
                $productStockMessage.text(data.message);
            } else {
                $productStockMessage.text('');
            }
        });
    }
});
